import { ICopyable, IOpObject, IOpChangeState, IOpData, IReferenceType } from '../util/interfaces'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataList } from '../util/op-data-list'
import { OpDistributor } from './op-distributor'
import { OpLocation } from './op-location'
import { OpTariffScheme } from '../custom/op-tariff-scheme'
import { OpTariffData } from './op-tariff-data'

import { DataProvider } from  '../../helpers'


export class OpTariff implements IReferenceType, IOpObject, IOpChangeState, ICopyable<OpTariff> {

    // #region Properties

    public idTariff: number
    public idDistributor: number
    public name: string

    // #endregion


    // #region Navigation Properties

    public distributor: OpDistributor

    // #endregion


    // #region Custom Properties

    public tariffOptions: OpTariffScheme[] = []
    public currentLocations: OpLocation[] = []

    // #endregion


    // #region  Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpTariff) {
            this.copy(<OpTariff>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion Ctor
    

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdTariff
    }

    public getReferenceKey(): number {
        return this.idTariff
    }

    public getReferenceValue(): any {
        return this
    }

    // #endregion


    // #region IOpObject implementation

    public get idObject(): any {
        return this.idTariff
    }

    public set idObject(idObject: any) {
        this.idTariff = idObject
    }

    public dataList: OpDataList<OpTariffData> = new OpDataList<OpTariffData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
           this.idTariff = opObj.ID_TARIFF
           this.idDistributor = opObj.ID_DISTRIBUTOR
           this.name = opObj.NAME

           this.distributor = opObj._Distributor != null ? new OpDistributor(opObj._Distributor) : null

           if (opObj.TariffOptions != null) {
               this.tariffOptions.push(...opObj.TariffOptions.map((tariffOption: OpTariffScheme) => new OpTariffScheme(tariffOption)));
           }

           if (opObj.CurrentLocations != null) {
               this.currentLocations.push(...opObj.CurrentLocations.map(locationData => new OpLocation(locationData)));
           }

           this.opState = opObj.OpState

           if (opObj.DataList != null) {
               this.dataList.push(...opObj.DataList.map(data => new OpTariffData(data)))
           }

           this.dynamicValues = opObj.dynamicValues
        } else {
            this.idTariff = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_TARIFF: this.idTariff,
            ID_DISTRIBUTOR: this.idDistributor,
            NAME: this.name,
            _Distributor: this.distributor != null ? this.distributor.toJSON() : null,
            TariffOptions: this.tariffOptions != null ? this.tariffOptions.map((tariffOption: OpTariffScheme) => tariffOption.toJSON()) : null,
            CurrentLocations: this.currentLocations != null ? this.currentLocations.map((currentLocation: OpLocation) => currentLocation.toJSON()) : null,
            OpState: this.opState,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
        }
    }

    public toString(): string {
        return this.name
    }

    // #endregion


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpTariff[]): JQueryPromise<OpTariff[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }

    public static fromIOpObject(object: IOpObject): OpTariff {
        const newObject: OpTariff = new OpTariff(null)

        newObject.idTariff = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpTariffData.fromIOpData(data)))

        return newObject
    }


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTariff {
        const tariff: OpTariff = new OpTariff()

        tariff.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return tariff
    }

    public copy(source: OpTariff, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.distributor = source.distributor != null ? source.distributor.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            source.tariffOptions != null
                ? this.tariffOptions = source.tariffOptions.map((scheme: OpTariffScheme) => scheme.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues))
                : this.tariffOptions = null

            this.currentLocations = source.currentLocations // TODO Zaimplementować ICopyable
        }

        if (includeDataList) {
            if (source.dataList != null) {
                source.dataList.toArray().forEach((data: OpTariffData) => {
                    this.dataList.push(data.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues))
                })
            }
        }

        if (includeDynamicValues) {
            this.dynamicValues = source.dynamicValues
        }

        this.idTariff = source.idTariff
        this.idDistributor = source.idDistributor
        this.name = source.name

        this.opState = source.opState
    }

    // #endregion 

}

